import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom"
import { EmptyCart, getCartDetails } from "../../../../../Redux/Actions";
// import crossIcon from "../../../../Assets/svg/metroCross.svg";
import headerStyles from "../../DesktopHeader.module.css";
import pathologyModalStyles from "./PathologyModal.module.css";
import Modal from "react-responsive-modal";

const modalStyle = {
  width: "550px",
};

const Pathology = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const cartDetails = useSelector(state => state.CartReducer.cartDetails);
  const [cartLength, setCartLength] = useState(0);
  const [openPath, setOpenPath] = useState(false);
  const onCloseModalPath = () => setOpenPath(false);

  useEffect(() => {
    // console.log("Cart", cartDetails);
    let len = 0;
    if (cartDetails && cartDetails?.length) {
      len = cartDetails[0]?.product?.length ?? 0;
    }
    setCartLength(len);
  }, [cartDetails]);

  const onPathologyClick = () => {
    if (cartLength) {
      setOpenPath(true);
    } else {
      // history.push("/");
      window.location.href = `${process.env.RAZZLE_APP_BASE_URL}`;
    }
  };

  const handleEmptyCartSubmit = () => {
    try {
      const userProfile = JSON.parse(localStorage.getItem("user"));
      const token = userProfile && userProfile.token;
      if (token) {
        dispatch(EmptyCart(token));
        setTimeout(() => {
          // history.push("/");
          dispatch(getCartDetails(token))
          window.location.href = `${process.env.RAZZLE_APP_BASE_URL}`;
        }, 400);
      } else {
        // history.push("/");
        window.location.href = `${process.env.RAZZLE_APP_BASE_URL}`;
      }
    } catch {
      // history.push("/");
      window.location.href = `${process.env.RAZZLE_APP_BASE_URL}`;
    }
  };
  return (
    <>
      {/* PATHOLOGY TAB */}
      <div
        className={`${headerStyles.navTab}`}
        onClick={onPathologyClick}
        style={{ cursor: "pointer" }}
      >
        <span className={`${headerStyles.navTabText}`}>Pathology</span>
      </div>

      {/* MODAL TO SHOW IF CART IS NOT EMPTY  */}
      <Modal
        open={openPath}
        onClose={onCloseModalPath}
        center
        styles={{
          modal: modalStyle,
        }}
        // closeIcon={crossIcon}
      >
        {/* <div onClick={onCloseModalImg} className={pathologyModalStyles.modalCloseButton}>
          <CrossIcon />
        </div> */}
        <div className={pathologyModalStyles.container}>
          <h2 className={pathologyModalStyles.ques}>
            Are you sure you want to empty your cart ?
          </h2>
          <div className={pathologyModalStyles.optionsDiv}>
            <span
              className={pathologyModalStyles.option}
              onClick={onCloseModalPath}
            >
              No
            </span>
            <span
              className={pathologyModalStyles.option}
              onClick={handleEmptyCartSubmit}
            >
              Yes
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Pathology;
